import React, { useEffect } from "react";
import Modal from "../components/ModalComonent";
import HappyEmoji from "../images/icons/smiley-emoji.gif";
import SadEmoji from "../images/icons/fluent-emoji.gif";
import Classes from "./styles/style.module.css";
import Confetti from "react-confetti";
import CuurectSound from "../Audio/win.mp3";
import FlaseSound from "../Audio/lose.mp3";

const WinModal = ({ show, handleClose, prize, desc, type }) => {
  const winAudio = new Audio(CuurectSound);
  const lossAudio = new Audio(FlaseSound);

  useEffect(() => {
    const soudMuted = JSON.parse(localStorage.getItem("soudMuted"));
    if (show && soudMuted) {
      if (type !== "empty") {
        winAudio.play();
      } else {
        lossAudio.play();
      }
    }
  }, [show]);

  const WinDialog = (
    <>
      <div className="w-100 text-center">
        <img
          src={HappyEmoji}
          alt="confetti-gif"
          className={Classes.confettiImage}
        />
        <p className="text-center">{` ${prize} بردی!!!`}</p>
        <p className="text-center">{desc}</p>
      </div>
    </>
  );

  const LossDialog = (
    <div className="w-100 text-center">
      <img
        src={SadEmoji}
        alt="confetti-gif"
        className={Classes.confettiImage}
      />
      <p className="text-center">چیزی نبردی !!!</p>
      <p className="text-center">دوباره تلاش کن</p>
    </div>
  );

  return (
    <>
      <Modal
        open={show}
        closeHandler={handleClose}
        dialogContent={type === "empty" ? LossDialog : WinDialog}
      />
      {show && type !== "empty" ? (
        <Confetti width={window.innerWidth} height={window.innerHeight} />
      ) : null}
    </>
  );
};

export default WinModal;
